import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_ContactNumber.scss'
import libPhoneNumber from 'google-libphonenumber'
import {
    Form
} from 'react-bootstrap'
import PropTypes from 'prop-types';

const PNF = libPhoneNumber.PhoneNumberFormat
const phoneUtil = libPhoneNumber.PhoneNumberUtil.getInstance()

class ContactNumber extends React.Component {
  static propTypes = {
    number: PropTypes.object.isRequired,
    labelAsHeading: PropTypes.bool,
    numberClass: PropTypes.string
  };

  render () {
    const number = this.props.number
    const phoneNumber = phoneUtil.parse(number.contactNumber, 'ZA')
    const label = this.props.labelAsHeading ? <h4 style={{fontFamily: 'Merriweather', marginBottom: '1rem'}}>{number.contactNumberType}</h4>
      : <Form.Label className={styles['adviser-control-label']}>{number.contactNumberType}</Form.Label>
    return (
      <Form.Group>
        {label}
        <p style={{marginBottom: '40px'}}>
          <a className={'phone-number ' + styles['adviser-phone-number']} href={'tel:' + number.contactNumber}>{phoneUtil.format(phoneNumber, PNF.INTERNATIONAL)}</a>
        </p>
      </Form.Group>
    )
  }
}

export default  (ContactNumber)
